import { render } from "./desc.vue?vue&type=template&id=6bb693d5"
import script from "./desc.vue?vue&type=script&lang=js"
export * from "./desc.vue?vue&type=script&lang=js"

import "./desc.vue?vue&type=style&index=0&id=6bb693d5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__